export enum CommunicationTriggerType {
  ManualTriggerType = 'Manual',
  ManualTriggerTypeIndexId = 10,
}